import { atom } from 'jotai';

const summaryPanelAtom = atom(true);
const metricPanelAtom = atom(true);
const dimensionPanelAtom =  atom(true);

const panelsAtom = atom((get) => {
  return {
    summary: get(summaryPanelAtom),
    metric: get(metricPanelAtom),
    dimension: get(dimensionPanelAtom),
  }
});

export {
  summaryPanelAtom,
  metricPanelAtom,
  dimensionPanelAtom,
  panelsAtom,
}
